import { SteemActionType } from '@popup/steem/actions/action-type.enum';
const TokensPendingUnstakingReducer = (state = [], { type, payload }) => {
    switch (type) {
        case SteemActionType.LOAD_PENDING_UNSTAKING:
            return payload;
        default:
            return state;
    }
};
export default TokensPendingUnstakingReducer;
